import $ from 'jquery'
import Spinner from './spin.min'

function SpinnerController(notCreateDefaultSpinner)
{
    if (!notCreateDefaultSpinner)
    {
        this._spinner = new Spinner(SpinnerController.getDefaultSettings());
    }
}

SpinnerController.getDefaultSettings = function()
{
    var safeCopy = {};
    $.extend(true, safeCopy, {
        lines: 11, // The number of lines to draw
        length: 3, // The length of each line
        width: 2, // The line thickness
        radius: 4, // The radius of the inner circle
        corners: 1, // Corner roundness (0..1)
        rotate: 0, // The rotation offset
        direction: 1, // 1: clockwise, -1: counterclockwise
        color: '#bbbbbb', // #rgb or #rrggbb
        speed: 1, // Rounds per second
        trail: 60, // Afterglow percentage
        shadow: false, // Whether to render a shadow
        hwaccel: false, // Whether to use hardware acceleration
        className: 'spinner', // The CSS class to assign to the spinner
        zIndex: 2e9, // The z-index (defaults to 2000000000)
        top: 'auto', // Top position relative to parent in px
        left: 'auto' // Left position relative to parent in px
    });
    return safeCopy;
};

SpinnerController.prototype = {
    setSpinner: function(spinner)
    {
        this._spinner = spinner;
    },

    spin: function(spinnerContainerId)
    {
        if (spinnerContainerId)
        {
            this._spinner.spin();
            document.getElementById(spinnerContainerId).appendChild(this._spinner.el);
        }
    },

    stop: function()
    {
        this._spinner.stop();
    },

    spinInElement: function(element)
    {
        if (element)
        {
            this._spinner.spin();
            element.append(this._spinner.el);
        }
    }
};

export default SpinnerController



// WEBPACK FOOTER //
// ./web/js/SpinnerController.js